import { render } from "./TwitterTimeline.vue?vue&type=template&id=2fd0b2f4"
import script from "./TwitterTimeline.vue?vue&type=script&lang=js"
export * from "./TwitterTimeline.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shion\\WebstormProjects\\ynufes_seiryo22_vue\\node_modules\\.pnpm\\vue-loader@17.0.0_webpack@5.72.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__